import { Request } from '~src/httpClient/serverApi/requests/Request';

import { IContentTypeInfo } from '../types/IContentTypeInfo';

/**
 * The VizPortal `listSupportedContentTypes` Web Client method — the content types currently
 * supported for selection, scoped to the authenticated Actor's site. A passthrough to the
 * tabhf-content-mobility `listSupportedContentTypes` RPC (content_selection.proto).
 *
 * The method returns a bare array (the monolith's `List<ContentTypeInfoViewModel>`), or an `{ errors }`
 * object on failure.
 */
export class GetSupportedContentTypesRequest extends Request<{}, IContentTypeInfo[]> {
  constructor() {
    super('listSupportedContentTypes', {});
  }
}
